import React from 'react'

const ProfileHeader = (props) => {
    return (
        <div className="profile-header">
            <div className="header-background" style={{
                background: 'linear-gradient(135deg, #01A982, #026f56)',
                height: '400px',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div className="header-overlay" style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)'
                }}></div>
                <div className="header-content" style={{
                    position: 'absolute',
                    bottom: '40px',
                    left: '40px',
                    color: 'white'
                }}>
                    <h1 style={{
                        fontSize: '3rem',
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        color: 'white'
                    }}>{props.title}</h1>
                    <div className="header-subtitle" style={{
                        fontSize: '1.2rem',
                        opacity: 0.8
                    }}>
                        {props.subtitle}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileHeader;